import React, {useEffect, useMemo, useState, useCallback} from "../../../../__snowpack__/pkg/react.js";
import {Modal, Form, Row, Select, Col, InputNumber, Table, Button, Popover} from "../../../../__snowpack__/pkg/antd.js";
import {InputNumberInteger} from "../../InputNumberInteger.js";
import {EllipsisShowTooltip} from "../../EllipsisShowTooltip/index.js";
import {PopoverImg} from "../../PopoverImg/index.js";
import noProductIcon from "../../../assets/no-product-icon.png";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import request from "../../../utils/request/index.js";
import {debounce} from "../../../../__snowpack__/pkg/lodash.js";
import {useRequest} from "../../../../__snowpack__/pkg/ahooks.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
import "./index.module.css";
import {useUpdateRoute} from "../../../lib/useIframe.js";
const ModalWrapper = styled(Modal)`
  .ant-table-cell {
    vertical-align: top;
  }
`;
export default function PrintModal(props) {
  const [form] = Form.useForm();
  const {visible, onOk, onCancel, masterProductIds} = props;
  const {formatMessage} = useIntl();
  const {updateRoute} = useUpdateRoute();
  const [removeIds, setRemoveIds] = useState([]);
  const [templateData, setTemplateData] = useState({
    generateMethod: "SPU"
  });
  const [tableData, setTableData] = useState([]);
  const {
    run: getTemplateList,
    data: templateList = [],
    loading
  } = useRequest((params) => request.post("/saas/product-setting/get-setting-list", {
    settingType: "PRINT_TEMPLATE",
    confType: "SETTING",
    keyword: params?.keyword || "",
    keywordType: "PRINT_TEMPLATE_NAME"
  }), {
    manual: true
  });
  const {runAsync: handleSubmit, loading: submitLoading} = useRequest((params) => request.post("/saas/product-print/print-barcode", params), {
    manual: true
  });
  const initData = async () => {
    const tableData2 = await request.post("/saas/master-product/search-simple-list", {
      masterProductIds
    });
    setTableData(Array.isArray(tableData2) ? tableData2 : []);
  };
  useEffect(() => {
    if (visible) {
      form.resetFields();
      setRemoveIds([]);
      setTemplateData({generateMethod: "SPU"});
      initData();
      getTemplateList({});
    }
  }, [visible, masterProductIds]);
  const handleMassNumber = () => {
    const massNumber = form.getFieldValue("massNumber");
    const printNumberData = form.getFieldValue("printNumber") || {};
    Object.keys(printNumberData).forEach((key) => {
      printNumberData[key] = massNumber;
    });
    form.setFieldsValue({
      printNumber: printNumberData
    });
  };
  const handleRemove = (id) => {
    try {
      const copyIds = [...removeIds];
      copyIds.push(id);
      setRemoveIds(copyIds);
    } catch (error) {
      console.log("error", error);
    }
  };
  const filterTableData = useMemo(() => {
    if (templateData?.generateMethod == "SPU") {
      return tableData.map((item) => {
        return {...item, id: item?.productId};
      }).filter((item) => !removeIds.includes(item.id));
    }
    return tableData.map((item) => item?.variations.map((variation) => {
      return {...variation, productName: item?.productName, id: variation?.variationId};
    }))?.flat().filter((item) => !removeIds.includes(item.id));
  }, [templateData, tableData, removeIds]);
  const filterTableColumns = useMemo(() => {
    if (templateData?.generateMethod == "SPU") {
      return [
        {
          width: 80,
          title: formatMessage({id: "number"}),
          key: "orderNumber",
          render: (active, row, index) => {
            return index + 1;
          }
        },
        {
          title: formatMessage({id: "productImage"}) + "&" + formatMessage({id: "ProductName"}),
          key: "product",
          width: 240,
          render: (active, row, index) => {
            const {image, productName} = row;
            return /* @__PURE__ */ React.createElement(Row, {
              wrap: false
            }, /* @__PURE__ */ React.createElement(PopoverImg, {
              avatarSize: 64,
              previewImage: image || noProductIcon
            }), /* @__PURE__ */ React.createElement(EllipsisShowTooltip, {
              title: productName
            }));
          }
        },
        {
          title: "SPU",
          dataIndex: "spu"
        },
        {
          title: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "printQuantity"}), /* @__PURE__ */ React.createElement(Popover, {
            content: /* @__PURE__ */ React.createElement(Row, {
              gutter: 8
            }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Form.Item, {
              noStyle: true,
              name: "massNumber"
            }, /* @__PURE__ */ React.createElement(InputNumberInteger, null))), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Button, {
              type: "primary",
              onClick: handleMassNumber
            }, formatMessage({id: "confirm"})))),
            trigger: "click"
          }, /* @__PURE__ */ React.createElement(Button, {
            type: "link"
          }, formatMessage({id: "mass"})))),
          key: "number",
          render: (active, row, index) => {
            const {id} = row;
            return /* @__PURE__ */ React.createElement(Form.Item, {
              initialValue: 1,
              name: ["printNumber", id]
            }, /* @__PURE__ */ React.createElement(InputNumberInteger, {
              min: 1
            }));
          }
        },
        {
          title: formatMessage({id: "action"}),
          key: "action",
          render: (active, row, index) => {
            const {id} = row;
            return /* @__PURE__ */ React.createElement(Button, {
              type: "link",
              style: {padding: 0},
              onClick: () => handleRemove(id)
            }, formatMessage({id: "delete"}));
          }
        }
      ];
    }
    if (templateData?.generateMethod == "BARCODE") {
      return [
        {
          width: 80,
          title: formatMessage({id: "number"}),
          key: "orderNumber",
          render: (active, row, index) => {
            return index + 1;
          }
        },
        {
          title: formatMessage({id: "variantPicture"}) + "&" + formatMessage({id: "ProductName"}),
          key: "product",
          width: 240,
          render: (active, row, index) => {
            const {image, productName} = row;
            return /* @__PURE__ */ React.createElement(Row, {
              wrap: false
            }, /* @__PURE__ */ React.createElement(PopoverImg, {
              avatarSize: 64,
              previewImage: image || noProductIcon
            }), /* @__PURE__ */ React.createElement(EllipsisShowTooltip, {
              title: productName
            }));
          }
        },
        {
          title: formatMessage({id: "Barcode"}),
          dataIndex: "barcode"
        },
        {
          title: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "printQuantity"}), /* @__PURE__ */ React.createElement(Popover, {
            content: /* @__PURE__ */ React.createElement(Row, {
              gutter: 8
            }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Form.Item, {
              noStyle: true,
              name: "massNumber"
            }, /* @__PURE__ */ React.createElement(InputNumberInteger, null))), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Button, {
              type: "primary",
              onClick: handleMassNumber
            }, formatMessage({id: "confirm"})))),
            trigger: "click"
          }, /* @__PURE__ */ React.createElement(Button, {
            type: "link"
          }, formatMessage({id: "mass"})))),
          key: "number",
          render: (active, row, index) => {
            const {id} = row;
            return /* @__PURE__ */ React.createElement(Form.Item, {
              initialValue: 1,
              name: ["printNumber", id]
            }, /* @__PURE__ */ React.createElement(InputNumberInteger, {
              min: 1
            }));
          }
        },
        {
          title: formatMessage({id: "action"}),
          key: "action",
          render: (active, row, index) => {
            const {id} = row;
            return /* @__PURE__ */ React.createElement(Button, {
              type: "link",
              style: {padding: 0},
              onClick: () => handleRemove(id)
            }, formatMessage({id: "delete"}));
          }
        }
      ];
    }
    return [
      {
        width: 80,
        title: formatMessage({id: "number"}),
        key: "orderNumber",
        render: (active, row, index) => {
          return index + 1;
        }
      },
      {
        title: formatMessage({id: "variantPicture"}) + "&" + formatMessage({id: "ProductName"}),
        key: "product",
        width: 240,
        render: (active, row, index) => {
          const {image, productName} = row;
          return /* @__PURE__ */ React.createElement(Row, {
            wrap: false
          }, /* @__PURE__ */ React.createElement(PopoverImg, {
            avatarSize: 64,
            previewImage: image || noProductIcon
          }), /* @__PURE__ */ React.createElement(EllipsisShowTooltip, {
            title: productName
          }));
        }
      },
      {
        title: "MSKU",
        dataIndex: "sku"
      },
      {
        title: /* @__PURE__ */ React.createElement(React.Fragment, null, formatMessage({id: "printQuantity"}), /* @__PURE__ */ React.createElement(Popover, {
          content: /* @__PURE__ */ React.createElement(Row, {
            gutter: 8
          }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Form.Item, {
            noStyle: true,
            name: "massNumber"
          }, /* @__PURE__ */ React.createElement(InputNumberInteger, null))), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Button, {
            type: "primary",
            onClick: handleMassNumber
          }, formatMessage({id: "confirm"})))),
          trigger: "click"
        }, /* @__PURE__ */ React.createElement(Button, {
          type: "link"
        }, formatMessage({id: "mass"})))),
        key: "number",
        render: (active, row, index) => {
          const {id} = row;
          return /* @__PURE__ */ React.createElement(Form.Item, {
            initialValue: 1,
            name: ["printNumber", id]
          }, /* @__PURE__ */ React.createElement(InputNumberInteger, {
            min: 1
          }));
        }
      },
      {
        title: formatMessage({id: "action"}),
        key: "action",
        render: (active, row, index) => {
          const {id} = row;
          return /* @__PURE__ */ React.createElement(Button, {
            type: "link",
            style: {padding: 0},
            onClick: () => handleRemove(id)
          }, formatMessage({id: "delete"}));
        }
      }
    ];
  }, [templateData, handleRemove]);
  const handleCancel = () => {
    onCancel();
  };
  const handleOk = async () => {
    try {
      const formValues = await form.validateFields();
      const {column, columnGap, templateId, printNumber} = formValues;
      const params = {
        templateId,
        printType: "TEMPLATE_PRINT",
        printColNum: column,
        printFreeWidth: columnGap,
        keyIdType: templateData.generateMethod == "SPU" ? "M_PRODUCT_ID" : "M_VARIATION_ID",
        printProductInfoList: filterTableData.map((item) => {
          const {id} = item;
          return {
            keyId: id,
            printNum: printNumber[id]
          };
        })
      };
      if (tableData?.length > 0) {
        const result = await handleSubmit(params);
        const {url, failList, failNum, successNum} = result;
        url && window.open(url);
        onOk();
        Modal.confirm({
          width: 400,
          title: formatMessage({id: "printProductBarcode"}),
          className: "print-product-modal",
          icon: null,
          content: /* @__PURE__ */ React.createElement("div", {
            className: "print-product-modal-body"
          }, /* @__PURE__ */ React.createElement("div", {
            className: "print-product-title"
          }, formatMessage({id: "sucGeneratedOrFailed"}, {
            success: successNum,
            fail: /* @__PURE__ */ React.createElement("span", {
              className: "print-fail-num"
            }, failNum)
          })), failList.map((item, index) => /* @__PURE__ */ React.createElement("div", {
            className: "print-desc",
            key: index
          }, item?.failReason))),
          okText: null,
          cancelText: formatMessage({id: "close"}),
          okButtonProps: {style: {display: "none"}}
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleSearchBrand = useCallback(debounce((val) => {
    getTemplateList({
      keyword: val || ""
    });
  }, 500), [getTemplateList]);
  const getTypeMessage = (type) => {
    if (type == "SPU" || !type) {
      return "SPU";
    }
    if (type == "SKU") {
      return "MSKU";
    }
    if (type == "BARCODE") {
      return formatMessage({id: "Barcode"});
    }
    return "";
  };
  const handleChangeType = (id) => {
    const findItem = templateList.find((item) => item?.id == id) || {};
    setTemplateData({
      ...findItem,
      templateType: findItem?.printTemplate?.templateType,
      generateMethod: findItem?.printTemplate?.generateMethod || "SPU"
    });
  };
  const handleGoTemplate = () => {
    window.open("/setting/new-master-product-settings?activeKey=printTemplate");
  };
  return /* @__PURE__ */ React.createElement(ModalWrapper, {
    width: 770,
    visible,
    confirmLoading: submitLoading,
    onOk: handleOk,
    onCancel: handleCancel,
    title: formatMessage({id: "barcodePrinting"})
  }, /* @__PURE__ */ React.createElement(Form, {
    form,
    layout: "vertical"
  }, /* @__PURE__ */ React.createElement(Form.Item, {
    name: "templateId",
    rules: [
      {
        message: formatMessage({id: "pleaseSelect"}),
        required: true
      }
    ],
    label: /* @__PURE__ */ React.createElement(Row, {
      gutter: 8,
      align: "middle"
    }, /* @__PURE__ */ React.createElement(Col, null, formatMessage({id: "barcodeTemplate"})), /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Button, {
      type: "link",
      onClick: handleGoTemplate
    }, formatMessage({id: "setTemplate"}))))
  }, /* @__PURE__ */ React.createElement(Select, {
    onChange: handleChangeType,
    style: {width: "320px"},
    loading,
    filterOption: false,
    showSearch: true,
    onSearch: handleSearchBrand
  }, templateList?.length > 0 && templateList.map((item) => /* @__PURE__ */ React.createElement(Select.Option, {
    value: item.id
  }, item?.printTemplate?.templateName)))), /* @__PURE__ */ React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: true
  }, ({getFieldValue}) => {
    const column = getFieldValue("column");
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Form.Item, {
      label: `${formatMessage({id: "productInformationMaster"})}(${getTypeMessage(templateData?.generateMethod)})${templateData?.templateType == "BAR_CODE" ? formatMessage({id: "printMaxlengthTip"}) : ""} `
    }, /* @__PURE__ */ React.createElement(Table, {
      rowKey: "id",
      style: {width: "100%"},
      scroll: {y: "400px"},
      dataSource: filterTableData,
      columns: filterTableColumns,
      pagination: false
    })), /* @__PURE__ */ React.createElement(Form.Item, {
      name: "column",
      label: formatMessage({id: "paperPrintColumn"}),
      initialValue: "1"
    }, /* @__PURE__ */ React.createElement(Select, {
      style: {width: "320px"}
    }, /* @__PURE__ */ React.createElement(Select.Option, {
      value: "1"
    }, formatMessage({id: "numberRow1"})), /* @__PURE__ */ React.createElement(Select.Option, {
      value: "2"
    }, formatMessage({id: "numberRow2"})), /* @__PURE__ */ React.createElement(Select.Option, {
      value: "3"
    }, formatMessage({id: "numberRow3"})), /* @__PURE__ */ React.createElement(Select.Option, {
      value: "4"
    }, formatMessage({id: "numberRow4"})))), column != "1" && /* @__PURE__ */ React.createElement(Form.Item, {
      label: formatMessage({id: "columnGap"})
    }, /* @__PURE__ */ React.createElement(Row, {
      align: "middle"
    }, /* @__PURE__ */ React.createElement(Form.Item, {
      name: "columnGap",
      noStyle: true
    }, /* @__PURE__ */ React.createElement(InputNumber, {
      style: {width: "320px"},
      min: 0,
      max: 100,
      precision: 2
    })), /* @__PURE__ */ React.createElement("span", {
      style: {marginLeft: "4px"}
    }, "mm"))));
  })));
}
